import { render, staticRenderFns } from "./BankAccountDetails.vue?vue&type=template&id=262d45fb&scoped=true"
import script from "./BankAccountDetails.vue?vue&type=script&lang=js"
export * from "./BankAccountDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "262d45fb",
  null
  
)

export default component.exports